// removed by extract-text-webpack-plugin
module.exports = {"block":"Stores_block_2Oc4d","column":"Stores_column_3Dlb2","columnLanding":"Stores_columnLanding_hAy5h","store":"Stores_store_3fn_O","storeLanding":"Stores_storeLanding_1ycJv"};